import React from 'react';
import styled from 'styled-components';

export const DecisionsQuestionAnswer = styled.div`
  color: white;
  margin: auto;
`;

export const OptionContainer = styled.div`
  display: flex;
  flex: 1;
  padding: 15px;
  border: 1px solid #78a1bb;
  margin: 5px;
  cursor: pointer;
  text-align: center;
  border-color: ${(props) =>
    props.disabled
      ? props.is_correct
        ? "#63C132"
        : ""
      : "#78A1BB"} !important;
  color: ${(props) =>
    props.disabled
      ? props.is_correct
        ? "#63C132"
        : ""
      : "#78A1BB"} !important;
`;
